(function () {
  'use strict';

  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.countdown_timers = [];
      this.slide_timing = Number(this.getAttribute("slide-timing")) || 5000;
      this.slide_container = this.querySelector("[data-slide-container]");
      this.slides = this.slide_container.children;
      if (this.slides.length > 1) {
        this.setupSlides();
      }

      for (const el of this.slides) {
        if (el.hasAttribute("end-time")) {
          this.setupCountdown(el);
        }
      }
    }

    disconnectedCallback() {
      if (this.slide_interval) {
        window.clearInterval(this.slide_interval);
      }
      if (this.countdown_timers.length > 0) {
        this.countdown_timers.forEach(timer => {
          window.clearInterval(timer);
        });
      }
    }

    setupSlides() {
      this.slide_interval = window.setInterval( () => {
        // fade out current slide
        window.setTimeout( () => {
          this.slides[0].classList.remove("fadein");
        }, 400);

        window.setTimeout( () => {
          this.slide_container.appendChild(this.slides[0]);
        }, 400);

        // fade in next slide, now at parent.children[0] since we just moved the previous first slide to the end
        window.setTimeout( () => {
          this.slides[0].classList.add("fadein");
        }, 400);

        // since this all happened at the end of the 'slideTiming' interval, we now wait for slideTiming ms before next transition
      }, this.slide_timing);
    }

    setupCountdown(countdown_slide) {
      const post_timer_text = countdown_slide.getAttribute('post-timer-text') || "";
      const end_time = countdown_slide.getAttribute('end-time');
      const timer_element = countdown_slide.querySelector('[data-timer-element]');
      if (end_time != "") {
        const end = new Date(end_time).getTime();
        const now = new Date().getTime();
        let time_remaining = end - now;

        // also put the removal check up here to short circuit the interval if the timer is already expired
        this.checkAndHandleRemoval(time_remaining, countdown_slide, timer_element, post_timer_text);

        const interval_id = window.setInterval( () => {
          time_remaining = end - new Date().getTime();
          this.checkAndHandleRemoval(time_remaining, timer_element);
          timer_element.innerHTML = this.createDateStringFromTimeRemaining(time_remaining);
        }, 1000);
        countdown_slide.setAttribute("interval_id", interval_id);
        this.countdown_timers.push(interval_id);

      } else {
        timer_element.innerHTML = "";
      }
    }

    checkAndHandleRemoval(time_remaining, countdown_slide, timer_element, post_timer_text = "") {
      if (time_remaining < 0 && post_timer_text != "") {
        timer_element.innerHTML = post_timer_text;
        window.clearInterval(countdown_slide.getAttribute("interval_id"));
        return
      } else if (time_remaining < 0) {
        window.clearInterval(countdown_slide.getAttribute("interval_id"));
        countdown_slide.remove();
        return
      }
    }
    createDateStringFromTimeRemaining(time_remaining) {
      const days = Math.floor(time_remaining / (1000 * 60 * 60 * 24));
      const hours = Math.floor((time_remaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((time_remaining % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((time_remaining % (1000 * 60)) / 1000);
      return `${days}d ${hours}h ${minutes}m ${seconds}s`
    }
  }

  /* Generic tile group carousel
   * we're not using the shadow DOM, so don't attempt to style <product-group> directly, only its children
   * Assumptions:
   * - tiles are all the same width
   * How to use:
   *  <product-group>
   *    <div data-tile-container>
   *      <div class="product-tile">...</div>
   *      <div class="product-tile">...</div>
   *    </div>
   *    <button data-previous-arrow>Previous</button>
   *    <button data-next-arrow>Next</button>
   *  </product-group>
   * style however you like, add another container around data-tile-container, etc
   */
  class ProductGroup extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.tile_container = this.querySelector("[data-tile-container]");
      this.next_arrow = this.querySelector("[data-next-arrow]");
      this.previous_arrow = this.querySelector("[data-previous-arrow]");

      if (!this.tile_container || !this.next_arrow || !this.previous_arrow) {
        return;
      }

      try {
        this.setupIntersectionObserver();
        this.setupArrowScroll();
        this.previous_arrow.style.visibility = "hidden";
      } catch (err) {
        console.error("Error initializing ProductGroup: ", err);
      }
    }

    disconnectedCallback() {
      if (this.tile_observer) {
        this.tile_observer.disconnect();
      }
    }

    setupIntersectionObserver() {
      let lastTileObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.target === this.tile_container.firstElementChild) {
            this.previous_arrow.style.visibility = entry.isIntersecting ? "hidden" : "visible";
          }

          if (entry.target === this.tile_container.lastElementChild) {
            this.next_arrow.style.visibility = entry.isIntersecting ? "hidden" : "visible";
          }
        });
      }, {
        root: this.tile_container,
        threshold: 1
      });
      lastTileObserver.observe(this.tile_container.firstElementChild);
      lastTileObserver.observe(this.tile_container.lastElementChild);
    }

    setupArrowScroll() {
      let tiles = this.tile_container.querySelectorAll(".product-tile");
      let tileWidth = tiles != null && tiles.length > 0 ? tiles[0].getBoundingClientRect().width : 300;
      this.next_arrow.addEventListener("click", (e) => {
        this.tile_container.scrollBy(tileWidth, 0);
      });
      this.previous_arrow.addEventListener("click", (e) => {
        this.tile_container.scrollBy(-tileWidth, 0);
      });
    }
  }

  // WIP custom video element
  // - very WIP due to multiple different video setups across hero-simple, fifty-fifty, and get-hype (plus other smaller ones)

  // Dependencies: none
  // Usage: <lbp-video-player></lbp-video-player>
  // API:
  // required child elements:
  // - video
  // optional elements
  // - mute button (data-mute-button)
  // - unmute button (data-unmute-button)
  // - play button (data-play-button)
  // - pause button (data-pause-button)

  // start controls hidden with style attribute, this element decides what to show/hide

  // Description:
  // - pretty much the same as the video player from the fifty-fifty and hero-simple snippets, but as a custom element. just looking for
  //   and linking up the video element and controls, plus an intersection observer to handle autoplay when the video is scrolled into view

  // Upcoming features:
  // - save src/source video into local variables, remove from element, and swap them in when the video is scrolled into view or within some threshold
  //   as this is the only way to lazy-load videos since we can't directly control loading of the video element

  // TODO options/features to add:
  // - autoplay
  // - loop
  // - muted
  // - preload
  // - poster
  // - playsinline
  // - controls
  // - disable video until scrolled into view with intersection observer

  class LbpVideoPlayer extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.video_element = this.querySelector("video");
      this.play_button = this.querySelector("[data-play-button]");
      this.mute_button = this.querySelector("[data-mute-button]");
      this.unmute_button = this.querySelector("[data-unmute-button]");

      // attributes
      this.autoplay = this.getAttribute("autoplay") == 'true' ? true : false;
      this.can_pause = this.getAttribute("can-pause") == 'true' ? true : false;
      this.hide_volume_controls = this.getAttribute("hide-volume-controls") == 'true' ? true : false;

      if (!this.errorChecks()) return;

      // initial conditions
      this.setInitialIconState();
      this.setVolume(0.5);
      this.video_element.muted = true;
      this.setupIntersectionObserver();

      // add event listeners
      if (this.play_button) this.play_button.addEventListener("click", this.playHandler.bind(this));
      if (this.mute_button) this.mute_button.addEventListener("click", this.muteButtonHandler.bind(this));
      if (this.unmute_button) this.unmute_button.addEventListener("click", this.unmuteButtonHandler.bind(this));
      if (this.can_pause) {
        this.video_element.addEventListener("click", () => {
          if (this.video_element.paused) {
            this.playHandler();
          } else {
            this.pauseHandler();
            // if paused from user input, clear carousel interval if it exists
            if (window.heroIntervalTimer) {
              clearInterval(window.heroIntervalTimer);
            }
          }
        });
      }

      if (this.getAttribute("is-autoplay-video") == 'true') {
        this.playHandler('autoplay');
      }
    }

    // pause video when scrolled out of view
    setupIntersectionObserver() {
      this.intersection_observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (this.autoplay && entry.isIntersecting && this.video_element.paused) {
            this.playHandler();
          } else {
            this.pauseHandler();

          }
        }, { threshold: 0, root: null, rootMargin: "0px" });
      });
      this.intersection_observer.observe(this.video_element);
    }

    setInitialIconState() {
      if (!this.hide_volume_controls) {
        this.unmute_button.style.display = "block";
      }
      if (!this.autoplay) {
        this.play_button.style.display = "block";
      }
    }

    setVolume(volume) {
      this.video_element.volume = volume;
    }

    muteButtonHandler() {
      this.video_element.muted = true;
      this.toggleMuteButtons();
    }

    unmuteButtonHandler() {
      this.video_element.muted = false;
      this.toggleMuteButtons();
    }

    toggleMuteButtons() {
      if (this.video_element.muted) {
        this.mute_button.style.display = "none";
        this.unmute_button.style.display = "block";
      } else {
        this.unmute_button.style.display = "none";
        this.mute_button.style.display = "block";
      }
    }

    playHandler(callingFunc = "") {
      //console.log("video play", callingFunc ? "from " + callingFunc : "")
      this.video_element.play();
      this.togglePlayIcon();
    }

    pauseHandler() {
      this.video_element.pause();
      this.togglePlayIcon();
    }

    togglePlayIcon() {
      if (!this.play_button) return;
      if (this.video_element.paused) {
        this.play_button.style.display = "block";
      } else {
        this.play_button.style.display = "none";
      }

    }

    disconnectedCallback() {
      // disconnect intersection observer
      if(this.intersection_observer) this.intersection_observer.disconnect();
    }

    errorChecks() {
      // check for required elements
      return (!!this.video_element)
    }
  }

  // Dependencies: Vimeo player SDK, loaded by iframe from vimeo so  it *should* be there
  // Usage: <lbp-vimeo-player> [iframe code from vimeo ] </lbp-vimeo-player>
  // API:
  // required child elements:
  // - iframe from vimeo

  // Description:
  // - vimeo version of lbp-video-player
  // - no "can pause" option as vimeo videos can't have controls removed

  // Upcoming features:
  // - save src/source video into local variables, remove from element, and swap them in when the video is scrolled into view or within some threshold
  //   as this is the only way to lazy-load videos since we can't directly control loading of the video element


  class LbpVimeoPlayer extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.video_element = this.querySelector("iframe");
      this.player = new Vimeo.Player(this.video_element);

      // attributes
      this.autoplay = this.getAttribute("autoplay") == 'true' ? true : false;
      this.startsMuted = this.getAttribute("muted") == 'true' ? true : false;
      if (this.autoplay === true) { this.startsMuted = true; }

      if (!this.errorChecks()) return;

      // initial conditions
      this.setVolume(0.5);
      this.startsMuted ? this.muteButtonHandler() : this.unmuteButtonHandler();
      this.setupIntersectionObserver();

      // add event listeners
      this.video_element.addEventListener("click", () => {
        if (this.player.getPaused()) {
          this.playHandler();
        } else {
          this.pauseHandler();
          // if paused from user input, clear carousel interval if it exists
          if (window.heroIntervalTimer) {
            clearInterval(window.heroIntervalTimer);
          }
        }
      });

      if (this.autoplay) {
        this.player.on("loaded", () => {
          let poster = this.parentElement.querySelector("[data-desktop-video-poster]");
          if (poster) { poster.style.display = "none"; }
          this.playHandler();
        });
      }
    }

    // pause video when scrolled out of view
    setupIntersectionObserver() {
      this.intersection_observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (this.autoplay && entry.isIntersecting) {
            this.playHandler();
          } else {
            this.pauseHandler();
          }
        }, { threshold: 0, root: null, rootMargin: "0px" });
      });
      this.intersection_observer.observe(this.video_element);
    }

    muteButtonHandler() {
      this.player.setMuted(true).then().catch(e => console.error(e));
    }

    unmuteButtonHandler() {
      this.player.setMuted(false).then().catch(e => console.error(e));
    }

    playHandler(callingFunc = "") {
      //console.log("video play", callingFunc ? "from " + callingFunc : "")
      this.player.play().then().catch(e => console.error(e));
    }

    pauseHandler() {
      this.player.pause().then().catch(e => console.error(e));
    }

    setVolume(volume) {
      this.player.setVolume(volume).then().catch(e => console.error(e));
    }

    disconnectedCallback() {
      // disconnect intersection observer
      if(this.intersection_observer) this.intersection_observer.disconnect();
    }

    errorChecks() {
      // check for required elements
      return (!!this.video_element)
    }
  }

  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  class QuantityInput extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.decrementButton = this.querySelector('button[data-action="decrement"]');
      this.incrementButton = this.querySelector('button[data-action="increment"]');
      this.inputBox = this.querySelector('input');

      // might need to disable buttons after each click instead of only on value <= 0, the default state is not disabled so they will be re-enabled after new section arrives
      // and I'm not sure how the cart api responds to multiple clicks in quick succession
      this.decrementButton.addEventListener('click', this.clickHandler.bind(this));
      this.incrementButton.addEventListener('click', this.clickHandler.bind(this));
      this.inputBox.addEventListener('change', this.changeHandler.bind(this));
    }

    disconnectedCallback() {
      this.decrementButton.removeEventListener('click', this.clickHandler.bind(this));
      this.incrementButton.removeEventListener('click', this.clickHandler.bind(this));
      this.inputBox.removeEventListener('change', this.changeHandler.bind(this));
    }

    clickHandler(e) {
      const btn = e.target.closest('button');
      this.inputBox.value = parseInt(this.inputBox.value) + (btn.dataset['action'] == 'increment' ? 1 : -1);
      btn.disabled = btn.dataset.action == 'decrement' && this.inputBox.value <= 0;
      window.eventBus.pub('update-cart', {key: this.inputBox.dataset.key, quantity: Number(this.inputBox.value)});
    }
    changeHandler(e) {
      this.decrementButton.disabled = this.inputBox.value <= 0;
      window.eventBus.pub('update-cart', {key: this.inputBox.dataset.id, quantity: Number(this.inputBox.value)});
    }
  }

  // Dependencies: event-bus.js
  // Usage: <event-button event="event-name"><any-click-target>[...]</any-click-target></event-button>
  // Mainly used for triggering some event with no data, like toggling minicart. If you need to pass data, maybe just make another element
  class EventButton extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.children[0].addEventListener('click', this.clickHandler.bind(this));
    }

    disconnectedCallback() {
      this.children[0].removeEventListener('click', this.clickHandler.bind(this));
    }

    clickHandler(e) {
      e.preventDefault();
      const event = this.getAttribute('event');
      if (event) {
        window.eventBus.pub(event);
      }
    }
  }

  class AddToCartButton extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.children[0].addEventListener('click', this.clickHandler.bind(this));
      this.id = this.getAttribute('id');
      this.quantity = this.getAttribute('quantity') || 1;
    }

    disconnectedCallback() {
      this.children[0].removeEventListener('click', this.clickHandler.bind(this));
    }

    clickHandler(e) {
      e.preventDefault();
      window.eventBus.pub('add-to-cart', { items: [{id: this.id, quantity: this.quantity }] });
    }
  }

  // Simple scroll button - scroll any scroll target from anywhere
  // Attributes:
  // - direction: any scroll direction (left or top)
  // - distance: scroll amount in pixels (use negative values for scrolling left or up)
  // - behavior: smooth, etc
  // - target: data attribute of intended scroll target (i.e. 'scroll-list' would scroll the element with 'data-scroll-list')
  // TODO (v2)
  // - watch attributes for changes to allow dynamically changing scroll direction, distance, etc
  class ScrollButton extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.children[0].addEventListener('click', this.clickHandler.bind(this));
    }

    disconnectedCallback() {
      this.children[0].removeEventListener('click', this.clickHandler.bind(this));
    }

    clickHandler(e) {
      e.preventDefault();
      const scrollOptions = {};
      this.scrollTarget = document.querySelector(`[data-${this.getAttribute('target')}`);
      scrollOptions[this.getAttribute("direction")] = Number(this.getAttribute("distance"));
      scrollOptions["behavior"] = this.getAttribute("behavior");
      this.scrollTarget.scrollBy(scrollOptions);
    }
  }

  // Discount Input Custom Element
  // Submits a discount code to Shopify
  // Usage: wrap a single <input> element in a <discount-input>
  // Dependencies: cookies.js (js-cookie)
  class DiscountInput extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.input = this.querySelector('input');
      this.input?.addEventListener("change", (e) => {
        Cookies.set('discount_code', e.target.value);
      });
    }

    disconnectedCallback() {
      this.input = this.querySelector('input');
      this.input?.removeEventListener("change", (e) => {
        Cookies.set('discount_code', e.target.value);
      });
    }
  }

  class MinicartGiftCheckpoints extends HTMLElement {
    static observedAttributes = ['cart-total']

    constructor() {
      super();
      this.icons = {};
      this.checkpoints = [
        {
          amount: 50,
          label: 'Queen! You get FREE Shipping!',
          type: 'shipping',
          position: '-100%',
          icons: {
            bw: '',
            color: ''
          }
        },
        {
          amount: 75,
          label: 'Slay! You get a FREE Lip Liner!',
          type: 'gift',
          position: '-100%',
          icons: {
            bw: '',
            color: ''
          }
        },
        {
          amount: 100,
          label: 'Yas! You get a FREE Travel Mascara + Puff',
          type: 'gift',
          position: '-100%',
          icons: {
            bw: '',
            color: ''
          }
        }
      ];
    }

    connectedCallback() {
      this.cartTotal = Number(this.getAttribute('cart-total'));
      this.render();

      // FIXME direct copy from mounted()
      this.icons = window.minicartData.checkpointIcons || {};
      
      this.checkpoints.forEach(checkpoint => {
        checkpoint.icons = this.getIcons(checkpoint);
      });
    }

    attributeChangedCallback(name, oldval, newval) {
      if (name === 'cart-total') {
        this.cartTotal = Number(newval);
        this.render();
      }
    }

    render() {
      this.innerHTML = `
      <div class="minicart__progress-bar-container">
        <div class="minicart__progress-bar-messages">
          <div class="minicart__progress-bar-message">${this.currentLabel()}</div>
        </div>
        <div class="minicart__progress-bar">
          <div class="minicart__progress-bar-fill" style="width: ${this.progressBarWidth()}"></div>
          ${this.checkpointHTML()}
        </div>
      </div>
    `;
    }

    checkpointHTML() {
      return this.checkpoints.map( (checkpoint, index) => `
      <div class="minicart__progress-bar-checkpoint">
        <div class="minicart__progress-bar-checkpoint-label" style="left: ${( (index+1) / (this.checkpoints.length + 1)) * 100}%">
          <img src="${this.checkpointIsPassed(checkpoint) ? checkpoint.icons.color : checkpoint.icons.bw}" loading="lazy" />
        </div>
        <div class="minicart__progress-bar-checkpoint-amount" style="left: ${( (index+1) / (this.checkpoints.length + 1)) * 100}%">$${checkpoint.amount}</div>
      </div>
    `).join('')
    }

    getIcons(checkpoint) {
      // map the checkpoint type to the icon for color and bw
      return {
        bw: this.icons[checkpoint.type + '-bw'],
        color: this.icons[checkpoint.type + '-color']
      }
    }

    checkpointIsPassed(checkpoint) {
      const amounts = this.checkpoints.map(c => c.amount);
      const total = this.cartTotal / 100;
      const index = amounts.findLastIndex( amount => total >= amount );
      return this.checkpoints.slice(0, index+1).map(ch => ch.amount).includes(checkpoint.amount)
    }

    currentLabel() {
      // cart value is an integer amount of pennies
      const cartTotal = this.cartTotal;
      return cartTotal < 5000 ? `You are $${ ((5000 - cartTotal)/100).toFixed(2).replace('.00', '') } away from FREE Standard Shipping!` : 
              cartTotal < 7500 ? `You are $${ ((7500 - cartTotal)/100).toFixed(2).replace('.00', '') } away from a FREE Lip Liner!` :
              cartTotal < 10000 ? `You are $${ ((10000 - cartTotal)/100).toFixed(2).replace('.00', '') } away from a FREE Travel Mascara + Puff!` :
              "Big Slay! You've unlocked free standard shipping + 3 free gifts!"
    }

    progressBarWidth() {
      // find the smallest checkpoint is that is still larger than the current cartTotal
      const amounts = this.checkpoints.map(c => c.amount);
      const barSpacing = 100/(amounts.length + 1);
      const total = this.cartTotal / 100 > 100 ? 100 : this.cartTotal / 100;
      let nextCheckpoint = amounts.find( amount => amount > total );
      // cap the nextCheckpoint at the last checkpoint
      nextCheckpoint = nextCheckpoint === undefined ? amounts[amounts.length-1] : nextCheckpoint;

      // concept:
      // - some number of checkpoints evenly distributed across the center of the progress bar, with an equal amount before and after first/last checkpoint
      // - each section of the bar is: totalCheckpoints / (totalCheckpoints + 1), fill is % of that
      // - since each checkpoint is an equal amount of space, but may or may not be evenly divided portions of 100 (ex: 50, 75, 100)
      //   we calculate how many checkpoints we have passed and fill them in, then add the % of the distance to the next checkpoint
      const index = amounts.indexOf(nextCheckpoint);
      const filledBars = barSpacing * index; // will be 0 if nextCheckpoint is index 0, aka no checkpoints passed
      // this is the only somewhat complicated bit, calculating the distance between previous and next checkpoint
      const percentOfCurrentBar = ((total - (amounts[index-1] || 0)) / (nextCheckpoint - (amounts[index-1] || 0)) * barSpacing); // || 0 to handle index 0
      
      if (nextCheckpoint === Math.min(...amounts)) {
        return `${ percentOfCurrentBar }%` // before the first checkpoint
      } else if (amounts.find(amount => amount > total) === undefined) {
        return '100%' // past final checkpoint, fill in the rest of the bar
      } else {
        return `${ filledBars + percentOfCurrentBar }%` // in between checkpoints
      }
    }
  }

  class LbpYoutubePlayer extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
    }

    setupPlayer() {

    }

    disconnectedCallback() {

    }
    playHandler() {

    }
    pauseHandler() {

    }
  }

  class PlpPriceFilters extends HTMLElement {
    constructor() {
      super();
      this.markup = `
    <div class="plp-price-filters">
      <button class="plp-price-filters__button" data-price=40>UNDER $40</button>
      <button class="plp-price-filters__button" data-price=30>UNDER $30</button>
      <button class="plp-price-filters__button" data-price=20>UNDER $20</button>
      <button class="plp-price-filters__button" data-price=15>UNDER $15</button>
    </div>
    `;
      this.styles = `
    <style>
      plp-price-filters {
        margin: auto;
      }
      .plp-price-filters {
        display: flex;
        justify-content: center;
        gap: 0;
        margin: 0 auto 10px;
      }
      .plp-price-filters__button {
        padding: 0.5rem 1rem;
        background-color: #f5f5f5;
        color: black;
        border: 1px solid black;
        border-right: none;
        cursor: pointer;
        transition: background-color 0.3s, color 0.3s;
        font-size: 0.6rem;
      }
      .plp-price-filters__button:last-child {
        border-right: 1px solid black
      }
      .plp-price-filters__button.active {
        background-color: #000;
        color: #fff;
      }
      @media screen and (min-width: 768px) {
        plp-price-filters {
          margin: 0 0 0 auto;
        }
        .plp-price-filters {
          gap: 1rem;
          margin: 0 auto;
        }
        .plp-price-filters__button {
          font-size: 1rem;
          border-right: 1px solid black;
        }
      }
      @media (hover: hover) {
        .plp-price-filters__button:hover {
          background-color: #000;
          color: #fff;
        }
      }
    </style>
    `;

    }

    connectedCallback() {
      this.innerHTML = this.styles + this.markup;
      this.setupPriceFilters();
    }

    setupPriceFilters() {
      this.buttons = this.querySelectorAll('.plp-price-filters__button');
      this.buttons.forEach((button) => {
        button.addEventListener('click', (e) => {
          button.classList.toggle('active');
          button.selected = !button.selected;
          if (!button.selected) {
            window.eventBus.pub('price:filter', null);
            return
          }
          const price = e.target.dataset.price;
          window.eventBus.pub('price:filter', price);
        });
        window.eventBus.sub('price:filter', (e) => {
          if (e.detail === button.dataset.price) {
            button.classList.add('active');
          } else {
            button.classList.remove('active');
          }
        });
      });
    }
  }

  // Product display for BYO collection
  // Basically a mini-pdp experience in a pop-up modal
  // TODO
  // - swatch selector should be its own custom element
  // - needs a big refactor

  class ProductDisplayByo extends HTMLElement {
    constructor() {
      super();
      // Initialize DOM element cache
      this.elements = {
        addButton: null,
        swatchContainer: null,
        gallery: null,
        title: null,
        description: null,
        variantTitle: null,
        variantPrice: null
      };
    }

    connectedCallback() {
      // Cache all frequently accessed DOM elements
      this.elements = {
        addButton: this.querySelector('[data-add-to-bundle]'),
        swatchContainer: this.querySelector('[data-swatch-selector]'),
        gallery: this.querySelector('product-gallery'),
        title: this.querySelector('[data-product-title]'),
        description: this.querySelector('[data-product-description]'),
        variantTitle: this.querySelector('[data-variant-title]'),
        variantPrice: this.querySelector('[data-variant-price]')
      };

      this.currentProduct = 0;
      this.imageSources = JSON.parse(document.querySelector('[data-product-images]').innerText);

      if (this.elements.addButton) {
        this.elements.addButton.addEventListener('click', this.addButtonHandler.bind(this));
      }
      if (this.elements.swatchContainer) {
        this.elements.swatchContainer.addEventListener('click', this.variantClickHandler.bind(this));
      }

      // add listener to top-level grid container so we don't have a million event listeners
      document.querySelector('[data-discount-type]')?.addEventListener('click', (e) => {
        const tile = e.target.closest('[data-product-tile]');
        const trigger = e.target.closest('[data-modal-trigger]') || e.target.closest('[data-choose-options="colors"]');
        if (tile && trigger) {
          this.productId = tile.dataset.productTile;
          this.price = Number(tile.dataset.finalPrice) * 100;
          this.hasColors = tile.querySelector('[data-choose-options="colors"]') !== null;
          this.openModal();
        }
      });
      // modal close listener
      this.addEventListener('click', (e) => {
        if (!e.target.closest('[data-content]') || e.target.closest('[data-modal-close]')) {
          this.closeModal();
        }
      });
    }

    disconnectedCallback() {
      // Clean up cached elements
      this.elements = null;
    }

    openModal() {
      // Initialize gallery with product images
      this.elements.gallery.constructGallery(this.imageSources[this.productId]);

      const product = window.all_products[this.productId];
      // set product title and description
      this.elements.title.innerText = product.title;
      this.elements.description.innerHTML = product.description;

      // get variants and set up swatch selector, if applicable
      if (product.variants.length > 1) {
        this.updateSwatches(product.variants);
        this.elements.swatchContainer.classList.remove('hidden');
      }

      const firstVariant = product.variants[0];
      this.elements.addButton.dataset.addToCartByo = firstVariant.id;

      // connect variant selector to add to bundle button
      if (product.variants.length > 1) {
        let title = firstVariant.title;
        if (title.includes('Net Wt')) {
          title = title.split(' /')[0];
        }
        this.elements.variantTitle.innerText = title + ' - ';
        this.elements.variantPrice.innerText = this.formatMoney(firstVariant.price);
      } else {
        this.elements.variantPrice.innerText = this.formatMoney(this.price);
      }
      this.elements.addButton.dataset.featuredImage = product.featured_image;
      this.elements.addButton.dataset.rawPrice = this.price;

      // show modal
      this.classList.remove('hidden');
    }

    closeModal() {
      this.elements.swatchContainer.classList.add('hidden');
      this.elements.variantTitle.innerText = '';
      this.classList.add('hidden');
    }

    formatMoney(amt) {
      return `$${Shopify.formatMoney(amt, '{{ amount }}').replace('.00', '')}`;
    }

    updateSwatches(variants) {
      // Create document fragment for batch DOM updates
      const fragment = document.createDocumentFragment();
      
      // Add all swatch elements to fragment
      variants.forEach((variant) => {
        fragment.appendChild(this.createSwatchElement(variant));
      });

      // Clear container and append all swatches at once
      this.elements.swatchContainer.innerHTML = '';
      this.elements.swatchContainer.appendChild(fragment);
      
      // Pre-select first variant
      if (this.elements.swatchContainer.children.length > 0) {
        this.elements.swatchContainer.children[0].children[0].classList.add('active');
      }
    }

    createSwatchElement(variant) {
      const wrapper = document.createElement('div');
      wrapper.style.position = 'relative';
      wrapper.style.display = 'inline-block';
      
      const imgEl = document.createElement('img');
      imgEl.dataset.price = variant.price;
      imgEl.dataset.variantId = variant.id;
      imgEl.dataset.title = variant.title;
      imgEl.dataset.featuredImage = variant.featured_image.src;
      imgEl.alt = variant.title;
      imgEl.width = '36';
      imgEl.height = '36';
      imgEl.classList.add('cursor-pointer');
      
      if (!variant.available) {
        imgEl.style.opacity = '0.5';
        imgEl.style.pointerEvents = 'none';
        wrapper.style.position = 'relative';
        wrapper.style.display = 'inline-block';
        
        // Create diagonal line element
        const diagonalLine = document.createElement('div');
        diagonalLine.style.position = 'absolute';
        diagonalLine.style.top = '0';
        diagonalLine.style.left = '0';
        diagonalLine.style.width = '100%';
        diagonalLine.style.maxWidth = '36px';
        diagonalLine.style.height = '100%';
        diagonalLine.style.maxHeight = '36px';
        diagonalLine.style.background = 'linear-gradient(135deg, transparent 47%, white 47%, white 53%, transparent 53%)';
        diagonalLine.style.pointerEvents = 'none';
        diagonalLine.style.zIndex = '1';
        
        // Append image first, then diagonal line will be on top
        wrapper.appendChild(imgEl);
        wrapper.appendChild(diagonalLine);
      } else {
        wrapper.appendChild(imgEl);
      }

      if (variant.title !== undefined) {
        let title = variant.title;
        if (title.includes('Net Wt')) {
          title = title.split(' /')[0];
        }
        title = title.toLowerCase().replaceAll(' ', '-');
        // more edge cases for color swatches
        if (title.includes('dark/deep')) { title = title.replace('dark/deep', 'dark-deep'); }
        if (title.includes('o/s')) { title = title.replace('o/s', 'os'); }

        imgEl.src = `https://${Shopify.cdnHost}/shop/files/color-${title}.png`;
      } else {
        imgEl.src = variant.featured_image.src;
      }
      // fallback if these options don't have their own color swatches
      imgEl.onerror = (e) => {
        imgEl.src = variant.featured_image.src;
      };

      return wrapper;
    }

    addButtonHandler(e) {
      if (window.bundle) {
        window.bundle.addProductToBundle(this.elements.addButton);
        this.closeModal();
      }
    }

    variantClickHandler(e) {
      const target = e.target.closest('[data-variant-id]');

      if (target && this.productId) {
        const variantId = target.dataset.variantId;
        const variantPrice = target.dataset.price;

        let variantTitle;
        if (target.alt.includes('Net Wt')) {
          variantTitle = target.alt.split(' /')[0];
        } else {
          variantTitle = target.alt;
        }

        // Update selected swatch UI
        this.elements.swatchContainer.querySelectorAll('img').forEach((img) => {
          img.classList.remove('active');
        });
        target.classList.add('active');

        // Update button data and text
        this.elements.addButton.dataset.featuredImage = target.dataset.featuredImage;
        this.elements.addButton.dataset.rawPrice = variantPrice;
        this.elements.variantTitle.innerText = variantTitle;
        this.elements.variantPrice.innerText = this.formatMoney(variantPrice);
        this.elements.addButton.dataset.addToCartByo = variantId;

        // Update gallery with variant-specific images
        const handle = target.dataset.title.replaceAll(' ', '-').toLowerCase().replaceAll('/', '');
        this.elements.gallery.updateGallery(this.imageSources[this.productId], handle);
      }
    }
  }

  class ProductGallery extends HTMLElement {
    constructor() {
      super();
      this.currentImageIndex = 0;
      this.imageElements = [];
      // Initialize DOM element cache
      this.elements = {
        currentImage: null,
        leftScroll: null,
        rightScroll: null
      };
    }

    connectedCallback() {
      // Cache DOM elements
      this.elements = {
        currentImage: this.querySelector('[data-current-image]'),
        leftScroll: this.querySelector('[data-image-scroll-left]'),
        rightScroll: this.querySelector('[data-image-scroll-right]')
      };

      this.elements.leftScroll?.addEventListener('click', this.handleLeftScroll.bind(this));
      this.elements.rightScroll?.addEventListener('click', this.handleRightScroll.bind(this));
    }

    disconnectedCallback() {
      this.elements.leftScroll?.removeEventListener('click', this.handleLeftScroll.bind(this));
      this.elements.rightScroll?.removeEventListener('click', this.handleRightScroll.bind(this));
      // Clean up cached elements
      this.elements = null;
    }

    handleLeftScroll() {
      if (this.currentImageIndex > 0) {
        this.currentImageIndex--;
        this.swapImage(this.currentImageIndex);
      }
    }

    handleRightScroll() {
      if (this.currentImageIndex < this.imageElements.length - 1) {
        this.currentImageIndex++;
        this.swapImage(this.currentImageIndex);
        this.preloadImage(this.imageElements[this.currentImageIndex + 1]);
      }
    }

    preloadImage(node) {
      if (node && !node.src) {
        node.src = node?.dataset.src;
      }
    }

    swapImage(idx) {
      if (!this.imageElements[idx]) {
        return;
      }
      this.elements.currentImage.replaceWith(this.imageElements[idx]);
      this.elements.currentImage = this.imageElements[idx] ? this.imageElements[idx] : this.elements.currentImage;
    }

    constructGallery(sourceList) {
      // Reset state
      this.currentImageIndex = 0;
      this.imageElements = [];

      // Create document fragment for batch processing
      const fragment = document.createDocumentFragment();

      // Create all image elements and store references
      sourceList.forEach((img, i) => {
        const imgEl = document.createElement('img');
        imgEl.dataset.src = img.src;
        imgEl.alt = img.alt;
        imgEl.width = '350';
        imgEl.height = '437';
        imgEl.classList.add('w-full', 'aspect-[4/5]', 'object-contain', 'max-h-[45vh]');
        
        // Store reference in our array
        this.imageElements[i] = imgEl;
        
        // Add a clone to the fragment
        fragment.appendChild(imgEl.cloneNode(true));
      });

      // Preload first two images
      this.preloadImage(this.imageElements[0]);
      this.preloadImage(this.imageElements[1]);

      // Replace current image with first image
      if (this.imageElements[0]) {
        this.elements.currentImage.replaceWith(this.imageElements[0]);
        this.elements.currentImage = this.imageElements[0];
      }
    }

    updateGallery(sourceList, handle) {
      const filteredImages = sourceList.filter((img) => {
        const alt = img.alt.replaceAll(' ', '-').toLowerCase().replaceAll('/', '');
        return alt === handle || img.alt === 'all';
      });

      this.constructGallery(filteredImages);
    }
  }

  customElements.define("announcement-bar", AnnouncementBar);
  customElements.define("product-group", ProductGroup);
  customElements.define("lbp-video-player", LbpVideoPlayer);
  customElements.define("lbp-vimeo-player", LbpVimeoPlayer);
  customElements.define("localization-form", LocalizationForm);
  customElements.define("quantity-input", QuantityInput);
  customElements.define("event-button", EventButton);
  customElements.define("add-to-cart-button", AddToCartButton);
  customElements.define("scroll-button", ScrollButton);
  customElements.define("discount-input", DiscountInput);
  customElements.define("minicart-gift-checkpoints", MinicartGiftCheckpoints);
  customElements.define("lbp-youtube-player", LbpYoutubePlayer);
  customElements.define("plp-price-filters", PlpPriceFilters);
  customElements.define("product-display-byo", ProductDisplayByo);
  customElements.define("product-gallery", ProductGallery);

})();
